import { Injectable } from '@angular/core';
import { HttpClientService } from '@core/services/http-client/http-client.service';
import { API_URL_CONSTANT } from '@sharedModule/constants/api-url.constant';
import { DataGrid } from '@sharedModule/models/data-grid.model';
import { ResponseIdentity } from '@sharedModule/models/server-response-identity.model';
import { removeEmptyStrings } from '@sharedModule/utils/form.utils';
import { Observable } from 'rxjs';
import { RoleListInterface } from '../types/role-list';
import {
  RoleListFilter,
  defaultRoleListFilter,
} from '../types/role-list-filter';
import { AddRoleInterface, UpdateRoleInterface } from '../types/upsert-role';
import { PermissionListInterface } from '../../permissions/types/permission-list';

@Injectable({
  providedIn: 'root',
})
export class RoleService {
  constructor(private httpClient: HttpClientService) {}

  getRoleList(
    payload: RoleListFilter = defaultRoleListFilter
  ): Observable<ResponseIdentity<DataGrid<RoleListInterface[]>>> {
    return this.httpClient.post(
      API_URL_CONSTANT.role.getRoleList,
      removeEmptyStrings(payload)
    );
  }

  getRoleDetails(payload: {
    role_id: string;
  }): Observable<ResponseIdentity<RoleListInterface>> {
    return this.httpClient.post(API_URL_CONSTANT.role.getRoleDetails, payload);
  }

  addRole(payload: AddRoleInterface): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(API_URL_CONSTANT.role.addRole, payload);
  }

  updateRole(payload: UpdateRoleInterface): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(API_URL_CONSTANT.role.updateRole, payload);
  }

  getPermissionListData(): Observable<
    ResponseIdentity<PermissionListInterface[]>
  > {
    return this.httpClient.post(
      API_URL_CONSTANT.permission.getPermissionList,
      {}
    );
  }

  deleteRole(payload: { role_id: string }): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(API_URL_CONSTANT.role.deleteRole, payload);
  }
}
